export default "__VITE_PUBLIC_ASSET__52027989__"